import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';

import RadioOnIcon from '../../icons/radio-on.svg';
import RadioOffIcon from '../../icons/radio-off.svg';
import ChevronDownIcon from '../../icons/chevron-down.svg';
class TyresFilter extends Component {
    constructor(props) {
        super(props);
            this.state = {
            collapsed: true,

        };

        this.toggleShowMore = this.toggleShowMore.bind(this);   
    }

    toggleShowMore(event) {
        event.preventDefault();
        this.setState({
            collapsed: !this.state.collapsed,
        });


    }

    render() {
        const { allTyres, tyre, setSelectedTyre, selectedTyreId } = this.props;
        const isSelected = selectedTyreId === tyre.id;
        const { imageUrl} = tyre;
       
    
        if(allTyres) {

        return (
            
            <div className={`faceted-filter-wrapper`}>
               <label className={`faceted-filter ${isSelected
                        ? 'faceted-filter--selected'
                        : ''
                        }`}>
                <div className="faceted-filter-input-wrapper">
                    <input className="faceted-filter__input" type="checkbox"
                        onChange={(e) => 
                           !isSelected ? 
                           setSelectedTyre(tyre.id)
                           : e.stopPropagation()
                        
                        }
                        checked={isSelected}
                    />
                    <div className="faceted-filter__label">
                    { isSelected ?
                        <RadioOnIcon className="icon" />
                        :
                        <RadioOffIcon className="icon" />
                    }
                        <div className="faceted-filter-quantity-and-price">
                            <span className="faceted-filter__quantity">
                            {tyre.header}
                            </span>
                            <span className="faceted-filter__price">
                                {translate('configuration.tyrezeroprice')}
                            </span>
                        </div>
                    </div>
            
                    <div className="faceted-filter__show-more">
                        <a className={`faceted-filter__show-more-text ${!this.state.collapsed ? 'faceted-filter__show-more-text--open'
                                : ''
                            }`}
                         onClick={ (event) => this.toggleShowMore(event)}
                        >
                            <span>{!this.state.collapsed ? translate('product.showless') : translate('product.showmore')}</span>
                            <span>
                                <ChevronDownIcon className={`faceted-filter__show-more-icon icon ${!this.state.collapsed ? 
                                'faceted-filter__show-more-icon--open icon'
                                : 
                                ''
                                }`}
                                />
                            </span>
                        </a>
                    </div>
                    <p className={`faceted-filter__description--mobile-only ${!this.state.collapsed ? 'faceted-filter__description--mobile-only--show': ''
                            }`} dangerouslySetInnerHTML={{ __html: tyre.description }}></p>
                </div>

                <div className={`faceted-filter__divider-line ${isSelected ? 'faceted-filter__divider-line--selected': ''}`}></div>
                <div className="faceted-filter-image-and-description">
                    <div className="faceted-filter__image-wrapper show-for-large">
                        <img className="faceted-filter__image"src={imageUrl}/>
                    </div>
                        <p className={`faceted-filter__description faceted-filter__description--tyre show-for-large 
                    ${this.state.collapsed ? '' : 'faceted-filter__description--expanded'}`} dangerouslySetInnerHTML={{ __html: tyre.description }}></p>
                </div>
            </label>
        </div>
        )
    } else {
        <div>NO tyres</div>
    }
    }
}

export default TyresFilter;